import { createEnvironment } from './environment.base';

export const environment = createEnvironment({
  production: false,
  stage: 'acc',
});
